import React from 'react';

import ChangeRequestRow from './ChangeRequestRow';

/**
 * One table for every status, with the status segment above it. This replaces the
 * three stacked tables that each rendered a full-width header even when empty.
 *
 * The Department / cost centre column appears only on the unscoped report: on a
 * location's own tab every row names the same location.
 */
export default function ChangeRequestsTable({ rows, showLocation, onOpen, onDelete, deletingId }) {
    const columnCount = showLocation ? 10 : 9;

    return (
        <div className="inbud-table_wrapper bc-table-wrapper">
            <table className="inbud-table bc-table">
                <thead>
                    <tr>
                        {showLocation && <th scope="col">{$t('Department / cost centre')}</th>}
                        <th scope="col">{$t('Date')}</th>
                        <th scope="col">{$t('Change')}</th>
                        <th scope="col">{$t('Category')}</th>
                        <th scope="col">{$t('Requested by')}</th>
                        <th scope="col" className="bc-num">
                            {$t('Amount')}
                        </th>
                        <th scope="col">{$t('Source of funds · balance impact')}</th>
                        <th scope="col">{$t('Status')}</th>
                        <th scope="col">{$t('Approvers')}</th>
                        <th scope="col" />
                    </tr>
                </thead>
                <tbody>
                    {rows.length === 0 && (
                        <tr>
                            <td colSpan={columnCount} className="tw-text-center tw-text-charcoal-50">
                                {$t('No budget change requests for these filters.')}
                            </td>
                        </tr>
                    )}

                    {rows.map((row) => (
                        <ChangeRequestRow
                            key={row.id}
                            row={row}
                            showLocation={showLocation}
                            onOpen={onOpen}
                            onDelete={onDelete}
                            deleting={deletingId === row.id}
                        />
                    ))}
                </tbody>
            </table>
        </div>
    );
}
